export default __webpack_public_path__ + "static/media/chat-4.7b622fc0.JPG";